<div class="PGColorPicker">
        <div class="input-group">
                <span class="input-group-text">
                        <span class="PGColorDisplay" [style.backgroundColor]="value"></span>
                </span>
                <input [id]="fieldId" class="form-control" [readonly]="readonly" [(ngModel)]="value" (ngModelChange)="onValueChange()">
        </div>
</div>